import * as Yup from "yup";
import http from "../../core/service/http.js";
import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import "./login.css";
import Footer from "../footer/footer.js";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { handleError, handleSuccess } from "../../utils.js";
import { useDispatch, useSelector } from "react-redux";
import { setAuth } from "../../core/store/app-store/app-store.js";
import moment from "moment";



export const useLoginHook = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [checkBox, setCheckBox] = useState(false);
  const saveUsername = localStorage.getItem("username");
  let auth = useSelector((state) => state?.appStore?.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (auth && moment.utc(auth?.tokens.access.expires).isAfter(moment.utc())) {
      if (auth && auth.user[0].role_name == "admin") {
        navigate("/dashboard/generate-tokens");
      } else {
        navigate("/dashboard/verify-users");
      }
    }
  }, [auth, navigate]);

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleRememberMe = () => {
    setCheckBox(!checkBox);
  };

  const rememberMeCheck = (values) => {
    if (checkBox) {
      localStorage.setItem("username", values.email);
    }
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await http.post("/v1/auth/login", {
        email: values.email,
        password: values.password,
      });
      if (response) {
        handleSuccess("Login Successfully");
        localStorage.setItem("data", JSON.stringify(response.data));
        dispatch(setAuth(response.data));
        if (response.data && response.data.user[0].role_name == "admin") {
          navigate("/dashboard/generate-tokens");
        } else {
          navigate("/dashboard/verify-users");
        }
      }
    } catch (error) {
      if (error.response) {
        handleError(error.response.data.message);
      } else {
        handleError("Network error. Please try again later.");
      }
    } finally {
      setSubmitting(false); // Stop the loader regardless of success or failure
    }
  };

  return {
    showPassword,
    setShowPassword,
    checkBox,
    setCheckBox,
    saveUsername,
    validationSchema,
    togglePasswordVisibility,
    handleRememberMe,
    rememberMeCheck,
    handleSubmit,
  };
};
